import wrapWithProvider from "./store";
import pageWrapper from "./wrapPageElement";
import { polarTrackPageView } from "./src/services/polar";
export const wrapRootElement = wrapWithProvider;
import {
	forcedLogoutKey, customerTokenKey, customerSessionKey, loopTokenKey, REDIRECT_URL, STORE_ID
} from "./src/utils/constants";
import getStorageValue from "helpers/get-storage-value";
import "./src/styles/global.css";
import onNodeReady from "helpers/handle-dom-node";

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
	const isModal = location?.state?.modal;
	const preventUpdateScroll = location?.state?.preserveScroll;

	if (isModal || preventUpdateScroll)
		return false;

	return true;
};

export const onClientEntry = () => {
	// Check for token passed from main domain (for tagged users)
	const url = new URL(window.location);
	const tokenParam = url?.searchParams?.get("token");

	if (tokenParam) {
		try {
			const customerToken = JSON.parse(decodeURIComponent(tokenParam));
			localStorage.setItem(customerTokenKey, JSON.stringify(customerToken));

			// Clean up URL
			url?.searchParams?.delete("token");
			window.history.replaceState({}, "", url);

			// Skip the forced logout logic since we just received a valid token
			localStorage.setItem(forcedLogoutKey, "true");
			return;
		} catch (e) {
			console.error("Failed to parse token:", e);
		}
	}

	const forcedLogout = JSON.parse(localStorage.getItem(forcedLogoutKey));
	const customerToken = JSON.parse(localStorage.getItem(customerTokenKey));
	if (!forcedLogout && customerToken) {
		const logOutUrl = `https://shopify.com/${STORE_ID}/auth/logout?id_token_hint=${getStorageValue(
			customerTokenKey,
			"id_token",
			"local",
		)}&post_logout_redirect_uri=${REDIRECT_URL}`;

		window.localStorage.removeItem(customerTokenKey);
		window.sessionStorage.removeItem(customerSessionKey);
		window.localStorage.removeItem(loopTokenKey);
		window.location.href = logOutUrl;
	}
	localStorage.setItem(forcedLogoutKey, "true");
}

export const wrapPageElement = pageWrapper;

export const onRouteUpdate = () => {
	polarTrackPageView();

	let _conv_q;

	if (window && "_conv_q" in window) {
		_conv_q = window._conv_q;
	} else {
		_conv_q = [];
	}

	// Remove Typeform popover on specific route
	if (location.pathname !== "/tracking") {
    onNodeReady(".tf-v1-sidetab-button", (popover) => {
      popover.remove();
    });
  }
	_conv_q.push(["run","true"]);
};